<div *ngIf="!settings.isOnlyContent()" class="matero-container-wrap" [ngClass]="{'matero-sidenav-collapsed': options.sidenavCollapsed && options.navPos!=='top',
                 'matero-navbar-side': options.navPos==='side',
                 'matero-navbar-top': options.navPos==='top',
                 'matero-header-above': options.headerPos==='above',
                 'matero-header-fixed': options.headerPos==='fixed',
                 'matero-header-white': options.theme==='light'}" [dir]="options.dir">
    <ng-progress></ng-progress>

    <div class="scroll-top-btn" *ngIf="showScroll" (click)="scrollToTop()">
        <mat-icon>keyboard_arrow_up</mat-icon>
      </div>

      <button class="whatsapp-btn" *ngIf="whatsAppNumber != null" (click)="openWhatsApp()">
        <mat-icon  class="pointer" style="height:38px;width: 38px;padding:6px;color:#fff" svgIcon="svg_whatsapp"> </mat-icon> Contactar por WhatsApp
      </button>

    <!-- Header Above -->
    <app-header fxHide.lt-md #header class="matero-header" *ngIf="options.showHeader && options.headerPos==='above'" (toggleSidenav)="sidenav.toggle()" (toggleSidenavNotice)="sidenavNotice.toggle()" [showBranding]="true">
    </app-header>
    
    <mat-sidenav-container class="matero-container" autosize autoFocus>

        <mat-sidenav #sidenav class="matero-sidenav" [mode]="options.navPos==='top' ? 'over': isOver ? 'over' : 'side'" [opened]="options.navPos==='side' && options.sidenavOpened && !isOver" (openedChange)="sidenavOpenedChange($event)" (closedStart)="sidenavCloseStart()">

            <app-sidebar [showToggle]="!isOver" [showUser]="options.showUserPanel" [showHeader]="options.headerPos!=='above'" (toggleCollapsed)="toggleCollapsed()" [toggleChecked]="options.sidenavCollapsed" (toggleSidenav)="sidenav.toggle()">
            </app-sidebar>
        </mat-sidenav>

        <mat-sidenav #sidenavNotice position="end" mode="over">
            <app-sidebar-notice></app-sidebar-notice>
        </mat-sidenav>

        <mat-sidenav-content #content class="matero-content-wrap" (scroll)="onContentScroll()">
            <app-header #header class="matero-header" *ngIf="options.showHeader && options.headerPos!=='above'" [showToggle]="!options.sidenavCollapsed && options.navPos!=='top'" [showBranding]="options.navPos==='top'" (toggleSidenav)="sidenav.toggle()" (toggleSidenavNotice)="sidenavNotice.toggle()">
            </app-header>

            <app-topmenu fxHide.lt-md *ngIf="options.navPos==='top'"></app-topmenu>
            <div *ngIf="path != sharedService.buildRoute(['home']) && path != sharedService.buildRoute(['/']) && path != '/'" class="" style="
            background: var(--color-client-500);
            background: linear-gradient(130deg,  var(--color-client-500) 0%,
            var(--color-client-500) 20%, var(--color-client-500) 70%, var(--color-client-100) 100%);
                    
                    text-align: left;
                    padding: 10px 16px 5px 16px;
                        color: var(--color-client-text);
                        font-size: 1.3rem;margin-bottom: 0px;">
                        <div style="max-width: 1100px; margin: 0 auto;">
                            <h1 style="font-size:2rem;margin-top:0px!important;margin-bottom:0px!important;">{{title}}</h1>
                            <breadcrumb></breadcrumb>
                        </div>
                
            </div>
            <div class="ylv-wrapper" *ngIf="entity$ | async; let entity"  [ngClass]="{'mat-card-transparent': !entity?.web?.autoContent }">
                
                <mat-card style="padding: 0;" >
                    <div *ngIf="path == sharedService.buildRoute(['home']) || path == sharedService.buildRoute(['/']) || path == '/'" fxLayout="row wrap">
                        
                        <div class="m-b-16" fxFlex="100" fxFlex.gt-md="100">
                            
                            <router-outlet></router-outlet>
                        </div>
                    </div>
                    <div *ngIf="path != sharedService.buildRoute(['home']) && path != sharedService.buildRoute(['/']) && path != '/'" class="matero-content" fxLayout="row wrap">
                        <app-widget-banners [onlyBig]="true" *ngIf="breadcrumbDetail == null" fxFlex="100" class="matero-col"></app-widget-banners>
                        <div class="matero-col" fxFlex="100" fxFlex.gt-md="70">
                            <router-outlet></router-outlet>
                        </div>
                        <div class="matero-col ylv-widgets p-l-16 p-r-8" fxFlex="100" fxFlex.gt-sm="30">
                            <div class="matero-row" fxLayout="row wrap">
                                <div class="matero-col" fxFlex="100" fxFlex.gt-sm="100">
                                    <app-widgets></app-widgets>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-card>
            </div>

            <div class="footer"  style="margin-top: 20px;" *ngIf="entity$ | async; let entity">
                <mat-card-footer *ngIf="entity?.sponsor?.length > 0 && (entity.sponsor | filter : filterFunction).length > 0" class="sponsor-footer">
                    <app-sponsor></app-sponsor>
                </mat-card-footer>
                <div class="footer" style="border-top: 30px solid #fff;">
                    <img class="footer-logo" appImgFallback src="{{(entity.image) ? sharedService.getImage(entity.image) : sharedService.getImage(defaultImageEntity)}}" alt="logo" />
                    <div class="matero-content">
                        <div class="info-footer">
                            <div class="info" style="min-width: 200px;">
                                <div class="matero-branding-name" style="font-size: 1.2rem;font-weight: 600;">{{ entity.name }}</div>
                                <div class="footer-links" style="display:flex;margin-top:10px;padding: 0px;flex-direction: column;">
                                    <a *ngIf="entity.web.street"><i class="fa fa-map-marker-alt"></i> {{ entity.web.street }} </a>
                                    <a *ngIf="entity.web.tel1"><i class="fa fa-phone" style="width: 14px;"></i> {{ entity.web.tel1 }} <span *ngIf="entity.web.tel2"> - {{ entity.web.tel2 }}</span></a>
                                    <a *ngIf="entity.web.fax"><i class="fa fa-fax"></i> {{ entity.web.fax }} </a>
                                    <a *ngIf="entity.web.email"><i class="fa fa-envelope"></i> {{ entity.web.email }} </a>
                       
                                </div>
                            </div>

                            <div class="links" style="min-width: 200px;">

                                <div *ngIf="(entity?.sponsor?.length > 0 && (entity.sponsor | filter : filterFunction).length > 0) || entity?.shopUrl != null "class="matero-branding-name" style="font-size: 0.9rem;margin-bottom:10px;margin-top:0px;font-weight: 600;">{{"general.important_links" | translate }}</div>
                                <div class="footer-links" style="display:flex;margin-top:0px;flex-direction: column;padding:0px;">
                                    <a *ngIf="entity?.sponsor?.length > 0 && (entity.sponsor | filter : filterFunction).length > 0" [routerLink]="sharedService.buildRoute(['sponsors'])">
                                        <span class="menu-name">{{ "menu.sponsors" | translate }}</span>
                                    </a>
                                    <a *ngIf="entity?.shopUrl != null" href="{{entity?.shopUrl}}" target="new">
                                        <span class="menu-name">{{ "menu.shop_url" | translate }}</span>
                                    </a>
                                </div>

                                <div *ngIf="socials && socials.length > 0" class="matero-branding-name" style="font-size: 0.9rem;margin-bottom:10px;font-weight: 600;">{{"general.follow_us" | translate }}</div>
                                <span class="pointer m-b-16 m-t-16 m-l-8"  *ngIf="socials && socials.length > 0">
                                    <a *ngFor="let social of socials" style="color: var(--color-client-text);margin-left:6px;margin-right:6px" class="matero-toolbar-button  pointer" target="new" href="{{ social.value }}">
                                        <mat-icon class="pointer" *ngIf="social.icon.includes('svg_')" svgIcon="{{ social.icon }}" style="width: 20px;
                                        height: 22px;
                                        font-size: 20px;
                                        line-height: 20px;"> </mat-icon>
                                        <mat-icon class="pointer" *ngIf="!social.icon.includes('svg_')"> {{ social.icon }}</mat-icon>
                                  </a>
                                  </span>
                                  

                            </div>
                            
                            


                            
                            
                            
                            
                        </div>

                        <div class="footer-links" style="border-top: 1px solid #c1c1c1;margin-top:15px;padding:8px;padding-bottom:70px;align-items: start;">
                            <div>
                                <button style="padding-left:0px;" mat-button [routerLink]="sharedService.buildRoute(['page', 'legal-warning-privacy-policy'])">
                                <span class="menu-name" style="color:#fff;font-size:12px!important;">{{ "page.legal-warning-privacy-policy.title" | translate }}</span>
                            </button>
                            <button mat-button [routerLink]="sharedService.buildRoute(['page', 'cookies-policy'])">
                                <span class="menu-name" style="color:#fff;font-size:12px!important;">{{ "page.cookies-policy.title" | translate }}</span>
                            </button>
                            </div>
                            <div style="display: flex; align-items: center;">
                                <span style="margin-right: 10px;margin-top:10px;font-size: 10px;">Powered by</span>
                                <a href="https://www.yulava.com/" target="new">
                                    <img src="{{environment.assetsUrl}}assets/images/logo_yulava_white.svg" style="height: 30px;">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </mat-sidenav-content>
        
    </mat-sidenav-container>
    
</div>



<div *ngIf="settings.isOnlyContent()" class="matero-container-wrap">
    <mat-sidenav-container class="matero-container" autosize autoFocus>
        <mat-sidenav-content #content class="matero-content-wrap">
            <div class="ylv-wrapper" *ngIf="entity$ | async; let entity" [ngClass]="{'mat-card-transparent': !entity?.web?.autoContent }">
                <mat-card style="padding: 0;">
                    <div *ngIf="path == sharedService.buildRoute(['home']) || path == sharedService.buildRoute(['/']) || path == '/'" fxLayout="row wrap">
                        <div class="m-b-16" fxFlex="100" fxFlex.gt-md="100">
                            <router-outlet></router-outlet>
                        </div>
                    </div>
                    <div *ngIf="path != sharedService.buildRoute(['home']) && path != sharedService.buildRoute(['/']) && path != '/'" class="matero-content" fxLayout="row wrap">
                        <div class="matero-col" fxFlex="100" fxFlex.gt-md="100">
                            <router-outlet></router-outlet>
                        </div>
                    </div>
                    <div style="text-align: center;font-size: 0.7rem;">{{ 'general.generated' | translate }} <b><a style="color:#000" href="https://www.yulava.com" target="new">yulava.com</a></b></div>
                </mat-card>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>


